<template>
  <div
    class="flex flex-col w-52 group"
    @dblclick="() => emits('open', watchface.path)"
  >
    <!-- 预览图容器 -->
    <div
      class="relative flex items-center justify-center border-box overflow-hidden w-52 h-52 bg-[#404040] rounded-2xl border-[2px] border-solid border-[transparent] group-hover:border-[#0D84F2]"
    >
      <!-- 预览图 -->
      <img
        v-if="preview"
        :src="preview"
        class=""
        draggable="false"
        :style="{
          height: '160px'
          // width: size.width * scale + 'px'
          // background: '#000000'
        }"
      />
      <div
        v-if="watchface.isSample"
        class="absolute inset-0 bg-black/60 hidden group-hover:flex items-center justify-center"
      >
        <a-button
          class=""
          type="primary"
          @click="() => emits('open', watchface.path)"
          >使用样例</a-button
        >
      </div>
      <!-- 收藏按钮 -->
      <div
        v-if="!watchface.isSample"
        class="absolute top-2.5 right-2.5 flex items-center w-5 h-5"
      >
        <Icon
          class="group-hover:opacity-100"
          :class="{ 'opacity-0': !watchface.collect }"
          :icon="
            watchface.collect
              ? 'favourite_selected.svg'
              : 'favourite_unselected.svg'
          "
          :width="20"
          :height="20"
          fill="transparent"
          @click.stop="
            () => emits('changeCollect', watchface.path, !watchface.collect)
          "
          @dblclick.stop
        />
      </div>
    </div>
    <!-- title -->
    <div class="flex text-white w-52 overflow-hidden rounded-b-xl pt-2 px-2.5">
      <div class="flex flex-col w-full overflow-hidden">
        <div class="text-lg leading-none">
          <EditableTitle
            :tree-id="watchface.path"
            :title="watchface.title"
            class="h-8 text-lg"
            :submit="(path:string,val:string)=>emits('rename',path,val)"
            :valid="validName"
            :highlight-text="inputSearchValue"
            :disabled="watchface.isSample"
          />
        </div>
        <div class="text-sm opacity-60 mt-0">
          <span> {{ openTime }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue';
import { HistoryWatchfaceItem, WatchfaceDeviceType } from '@/hooks';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { validWatchfaceName } from '@/utils/watchface-valid.utils';

dayjs.extend(relativeTime);

const emits = defineEmits<{
  (event: 'open', path: string): void;
  (event: 'changeCollect', path: string, collect: boolean): void;
  (event: 'rename', path: string, val: string): void;
}>();
const props = defineProps({
  watchface: {
    type: Object as PropType<HistoryWatchfaceItem>,
    required: true
  },
  preview: {
    type: String,
    default: undefined
  },
  inputSearchValue: {
    type: String,
    default: undefined
  }
});

const validName = (id: string, newName: string) => {
  const res = validWatchfaceName(
    newName,
    props.watchface.deviceType as WatchfaceDeviceType
  );
  if (typeof res == 'string') return res;
  return '';
};

const openTime = computed(() => {
  const lastOpened = props.watchface.lastOpened;
  if (!lastOpened) return '';
  return dayjs(lastOpened).locale('zh-cn').fromNow();
});
</script>
<style scoped></style>
